import type { ConfigurableServer } from '@festina-life/core'
import { useQuery } from '@tanstack/react-query'

import { useStandardService } from '../../../hooks/useStandardService'
import { fetchStandardComponentConcisePackageKey } from '../keys'

type Props = {
  server: ConfigurableServer
  enabled?: boolean
}

export const useFetchStandardComponentConcisePackage = ({
  server,
  enabled = true,
}: Props) => {
  const service = useStandardService()

  // We intentionally use useQuery in order to avoid suspense from kicking in inside the branches panel,
  // making it snappier for users to click through branch in the branches tree.
  return useQuery({
    enabled,
    queryKey: fetchStandardComponentConcisePackageKey(server),
    queryFn: () =>
      service.api.ConfigurationChangesetsService.configurationServiceGetGetConciseChangesets(
        {},
      ),
  })
}
